import React from 'react';
import {AppBar, Box, Button, Toolbar} from '@mui/material';
import RegisterButton from "./RegisterButton";

const Header: React.FC = () => {
    return (
        <AppBar position="static" color={'transparent'}>
            <Toolbar sx={{flexGrow: 1}}>

                <img
                    src={'header/naukma-logo.svg'}
                    alt={'naukma'}
                    style={{width: 'auto', height: '40px' }}
                />

                <Box sx={{flexGrow: 1}}/>

                <NavigationButton/>

                <RegisterButton
                    text={'Реєстрація'}
                    margin={'0'}
                    padding={'10px 20px'}
                    sx={{
                        ml: 2,
                        display: 'none',
                        '@media (min-width:870px)': {
                            display: 'flex',
                        },
                        alignItems: 'center',
                    }}
                    onClick={() => {
                        window.location.href = 'https://forms.office.com/pages/responsepage.aspx?id=Q_7LuAzJ6kuErr5dbYpfUlAWM1TEgS9GgMUJnk2SY5pUQ1oyUjY2WDdOUFlaOFlZVTZQSTFYVFc0TC4u&route=shorturl';
                    }}
                />
            </Toolbar>
        </AppBar>
    );
};

interface NavigationHeaderProps {
    title: string;
    id: string;
}

const NavigationButton = () => {
    const buttons: NavigationHeaderProps[] = [
        {
            title: 'Про програму',
            id: 'about-course'
        },
        {
            title: 'Для кого курс',
            id: 'for-whom-course'
        },
        {
            title: 'Що чекає на вас',
            id: 'what-awaits'
        },
        {
            title: 'Питання',
            id: 'question'
        }
    ];

    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Box
            sx={{
                display: 'none',
                '@media (min-width:870px)': {
                    display: 'flex',
                },
                alignItems: 'center',
            }}
        >
            {buttons.map((button, index) => (
                <Button
                    key={index}
                    color="inherit"
                    onClick={() => scrollToSection(button.id)}
                    sx={{
                        color: '#062159',
                        fontFamily: (theme) => theme.typography.button.fontFamily,
                        fontSize: (theme) => theme.typography.button.fontSize,
                        fontWeight: (theme) => theme.typography.button.fontWeight,
                    }}
                >
                    {button.title}
                </Button>
            ))}
        </Box>
    );
}

export default Header;